import mailboxAxios from "./mailboxAxios";
import { auth } from "../firebase";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);

  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function getPushStatus() {
  const permission =
    typeof Notification !== "undefined" ? Notification.permission : "unsupported";

  if (!("serviceWorker" in navigator)) {
    return {
      supported: false,
      permission,
      subscribed: false,
      endpoint: null,
    };
  }

  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();

  return {
    supported: true,
    permission,
    subscribed: !!sub,
    endpoint: sub?.endpoint || null,
  };
}

export async function subscribeToPushNotifications() {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User is not logged in");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Notification permission not granted");
  }

  const reg = await navigator.serviceWorker.ready;

  const existingSub = await reg.pushManager.getSubscription();
  if (existingSub) {
    await mailboxAxios.post("/notifications/push/subscribe", {
      subscription: existingSub.toJSON(),
      platform: navigator.userAgent,
    });

    return existingSub;
  }

  const configRes = await mailboxAxios.get("/notifications/push/config");
  const publicKey = configRes.data?.publicKey;

  if (!publicKey) {
    throw new Error("Missing publicKey from backend");
  }

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  await mailboxAxios.post("/notifications/push/subscribe", {
    subscription: sub.toJSON(),
    platform: navigator.userAgent,
  });

  return sub;
}

export async function unsubscribeFromPushNotifications() {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();

  if (!sub) return false;

  const endpoint = sub.endpoint;

  await sub.unsubscribe();

  await mailboxAxios.post("/notifications/push/unsubscribe", {
    endpoint,
  });

  return true;
}

export async function sendTestPushNotification() {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User is not logged in");
  }

  await mailboxAxios.post("/notifications/push/test");
}